import { extendTheme } from '@chakra-ui/react';
import { theme as marketcastTheme } from '@marketcast/ui-kit';
import { globals } from './global';

/**
 * App theme = MarketCast UI Kit theme (source of truth for colors, fonts,
 * shadows and component styles) with our app-level global styles merged on top.
 *
 * Always prefer `marketcast.*` color tokens over raw hex values in components.
 */
const VOLTE_FONT_STACK = '"Volte", "Volte Regular", "Helvetica Neue", sans-serif';

export const theme = extendTheme(marketcastTheme, {
  styles: globals.styles,
  // This app uses Volte throughout (body AND headings), matching the dashboard
  // UI project. The ui-kit theme defaults headings to a serif (Sanomat Web),
  // so override both to Volte here.
  fonts: {
    heading: VOLTE_FONT_STACK,
    body: VOLTE_FONT_STACK,
  },
});
